import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SOToPOPreference } from '~/models/administration/soToPoPreference';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class SOToPOPreferencesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getSOToPOPreference() {
        return this.http.get<SOToPOPreference>(this._url());
    }

    updateSOToPOPreference(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/SOToPOPreferences${v}`);
    }
}